import React from "react";
import PropTypes from "prop-types";

const UnicliTooltip = ({ strongLine, mainLine }) => {
  return (
    <div>
      <strong>{strongLine}</strong>
      <div>{mainLine}</div>
    </div>
  );
};

UnicliTooltip.propTypes = {
  strongLine: PropTypes.string,
  mainLine: PropTypes.string,
};

export default UnicliTooltip;
